import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { openNotification } from "../../Components/Notification";
import appIntegrationService from "../../Service/app.integration.service";
import { Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import './index.scss';

const ZohoAuthCallBack: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleAuthCallback = async () => {
      setIsLoading(true);
      const code = searchParams.get("code");
      const error = searchParams.get("error");
      const state = searchParams.get("state");

      if (error) {
        openNotification("error", "OAuth Error", error);
        sessionStorage.removeItem("zoho_oauth_state");
        navigate("/organization?tab=apps", { replace: true });
        setIsLoading(false);
        return;
      }

      if (!code) {
        sessionStorage.removeItem("zoho_oauth_state");
        openNotification(
          "error",
          "Authentication Failed",
          "No authorization code received"
        );
        navigate("/organization?tab=apps", { replace: true });
        setIsLoading(false);
        return;
      }

      const storedState = sessionStorage.getItem("zoho_oauth_state");

      if (!state || state !== storedState) {
        sessionStorage.removeItem("zoho_oauth_state");
        navigate("/organization?tab=apps", { replace: true });
        openNotification("error", "Security Error", "Invalid state parameter");
        setIsLoading(false);
        return;
      }

      try {
        const response =
          await appIntegrationService.validateZohoRecruitConnection(code);

        if (!response?.success) {
          sessionStorage.removeItem("zoho_oauth_state");
          navigate("/organization?tab=apps", { replace: true });
          openNotification("error", "Error", response.message);
          setIsLoading(false);
          return;
        }

        openNotification(
          "success",
          "Connected Successfully",
          "Your Zoho Recruit account has been connected"
        );
        sessionStorage.removeItem("zoho_oauth_state");
        setIsLoading(false);
        navigate("/organization?tab=apps", { replace: true });
      } catch (error: any) {
        console.error(
          "🚀 ~ ZohoAuthCallBack ~ handleAuthCallback ~ error:",
          error
        );
        sessionStorage.removeItem("zoho_oauth_state");
        navigate("/organization?tab=apps", { replace: true });
        openNotification("error", "Error", error.message);
        setIsLoading(false);
        return;
      } finally {
        setIsLoading(false);
      }
    };

    handleAuthCallback();
  }, [searchParams, navigate]);

  return (
    <section className="dashbord-page auth-callback-page">
      <Spin indicator={<LoadingOutlined spin size={60} />} spinning={isLoading}>
        <div className="auth-callback-container">
          <div className="auth-callback-title">
            <Typography.Title level={4} style={{ margin: 0 }}>
              Please wait ...
            </Typography.Title>
          </div>
          <div className="auth-callback-content">
            <Typography.Text>
              We are connecting your Zoho Recruit account. This may take a few
              seconds.
            </Typography.Text>
          </div>
          <div className="auth-callback-footer">
            <Typography.Text type="secondary">
              Do not refresh or close the page while we are connecting your
              account
            </Typography.Text>
          </div>
        </div>
      </Spin>
    </section>
  );
};

export default ZohoAuthCallBack;
